import { Redirect, useLocation } from "react-router-dom";
import { BAAS_ACCOUNTS_PATH } from "../constants";

/** Legacy full-page create route → list with create modal open. */
export const BaasAccountCreatePage = () => {
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  params.set("create", "1");
  const search = params.toString();

  return <Redirect to={`${BAAS_ACCOUNTS_PATH}?${search}`} />;
};

export default BaasAccountCreatePage;
